export default [
    // 공지사항 현황
    {
        path: '/api/BullStat',
        name: 'BullStat',
        component: () => import('@/views/blbd/api/BullStat.vue')
    },
    // 공지사항 상세
    {
        path: '/api/BullDetl',
        name: 'BullDetl',
        component: () => import('@/views/blbd/api/BullDetl.vue')
    },

    // 건의사항 현황
    {
        path: '/api/SgstStat',
        name: 'SgstStat',
        component: () => import('@/views/blbd/api/SgstStat.vue')
    },
    // 건의사항 상세
    {
        path: '/api/SgstDetl',
        name: 'SgstDetl',
        component: () => import('@/views/blbd/api/SgstDetl.vue')
    },
    // 건의사항 등록
    {
        path: '/api/SgstSave',
        name: 'SgstSave',
        component: () => import('@/views/blbd/api/SgstSave.vue')
    },
]